import { useTranslation } from 'next-i18next';
import { type UseVoucherHandler, VOUCHER_STATUS_LABELS, type VoucherItem } from './type';
import { getRemainingTime } from './utils';
import { VoucherActionButton } from './VoucherActionButton';
import { VoucherStatusChip } from './VoucherStatusChip';
import { Cell } from './VoucherTableHeader';
interface VoucherTableRowProps {
  voucher: VoucherItem;
  onUseVoucher: UseVoucherHandler;
  isActivating: boolean;
}
export const VoucherTableRow = ({
  voucher,
  onUseVoucher,
  isActivating
}: VoucherTableRowProps) => {
  const {
    t
  } = useTranslation(['billing']);
  const renderExpiryDateContent = () => {
    if (voucher.status !== 'UNUSED') {
      return <span className="text-body-md-regular text-disabled">
          {t(VOUCHER_STATUS_LABELS[voucher.status])}
        </span>;
    }
    return <span className="text-body-md-regular text-default" data-sentry-component="renderExpiryDateContent" data-sentry-source-file="VoucherTableRow.tsx">
        {getRemainingTime(voucher.expirationDate, t)}
      </span>;
  };
  return <div key={voucher.id} className="flex min-h-[50px] w-full items-center bg-default" data-sentry-component="VoucherTableRow" data-sentry-source-file="VoucherTableRow.tsx">
      {/* 상태 */}
      <Cell content={<VoucherStatusChip status={voucher.status} />} className="w-[80px] mobile-lg:max-w-[160px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableRow.tsx" />

      {/* 이용권 이름 */}
      <Cell content={<div className="flex flex-col items-start justify-center text-ellipsis">
            <span className="text-body-md-medium">{voucher.name}</span>
            <span className="truncate text-caption-md-regular text-alternative">
              {voucher.code}
            </span>
          </div>} className="min-w-[160px] mobile-lg:min-w-[240px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableRow.tsx" />

      {/* 적용 플랜 */}
      <Cell content={<span className="text-body-md-regular text-default">
            {voucher.planDuration}
            {t('days')} ({voucher.planType})
          </span>} className="mobile-lg:max-w-[160px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableRow.tsx" />

      {/* 사용 기한 */}
      <Cell content={renderExpiryDateContent()} className="w-[120px] mobile-lg:max-w-[180px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableRow.tsx" />

      {/* 사용하기 버튼 */}
      <Cell content={<VoucherActionButton status={voucher.status} onUse={() => onUseVoucher({
      id: voucher.id,
      name: voucher.name,
      planType: `${voucher.planDuration} (${voucher.planType})`
    })} isDisabled={!voucher.canUseNow || isActivating} />} className="mobile-lg:max-w-[160px]" data-sentry-element="Cell" data-sentry-source-file="VoucherTableRow.tsx" />
    </div>;
};